module.exports = "/_next/static/images/698aa0bf39fb770a190b69e1a54a9206-card-and-phone-3d-md@1x.jpg.webp";